export const REACT_APP_VERSION = process.env.REACT_APP_VERSION || "1.0.37";
